import { useState, useEffect } from 'react';
import {
 Popover, PopoverButton, PopoverPanel, Transition,
} from '@headlessui/react';
import { usePopper } from 'react-popper';
import Icon from '@/core/icon.js';
import { hocTranslateServerClient } from '@/helpers/translate';
import { useSpacePublicZustandStore } from '@/helpers/spacepublicprovider';
import { queryEquipments } from './equipments';

const EnvironmentsItem = hocTranslateServerClient(({ t, i }) => {
  const [open, setOpen] = useState(false);
  const [refLabel, setRefLabel] = useState();
  const [refPopover, setRefPopover] = useState();

  const { styles, attributes } = usePopper(refLabel, refPopover, {
    placement: 'top',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [56, 8],
        },
      },
    ],
  });

  return (
    <Popover>
      <PopoverButton
        ref={setRefLabel}
        aria-label={t(`extra:name.${i.slug}`)}
        className="flex items-center justify-center mr-2 rounded-lg size-12 bg-purple-0"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        <Icon name={i.slug} className="fill-current text-purple-5/60 size-6" />
      </PopoverButton>
      <Transition
        as="div"
        className="relative z-50"
        show={open}
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <PopoverPanel
          className="px-3 py-2 text-sm text-white -translate-x-1/2 bg-black rounded-lg shadow-button left-1/2"
          static
          ref={setRefPopover}
          style={styles.popper}
          {...attributes.popper}
        >
          {t(`extra:name.${i.slug}`)}
        </PopoverPanel>
      </Transition>
    </Popover>
  );
});

export default function Environments({ data }) {
  if (!data?.length) return null;

  return (
    <div className="flex flex-col mt-10 text-sm">
      <div className="flex flex-wrap items-center mt-6 gap-y-2 lg:mt-0">
        {!data || data.map((d) => d.items.map((i) => <EnvironmentsItem {...{ i }} key={`spacepublicbycateenvironements${i.slug}`} />))}
      </div>
    </div>
  );
}
